/**
 * ============================================
 * TIME SCALE TOGGLE
 * ============================================
 *
 * Daily / Weekly / Monthly switch used on chart headers (Sony/DOMO and
 * Multiplayer tabs).
 */

export type TimeScale = 'daily' | 'weekly' | 'monthly';

const OPTIONS: { value: TimeScale; label: string }[] = [
  { value: 'daily', label: 'Daily' },
  { value: 'weekly', label: 'Weekly' },
  { value: 'monthly', label: 'Monthly' },
];

export function TimeScaleToggle({ scale, onChange, isDark }: { scale: TimeScale; onChange: (s: TimeScale) => void; isDark: boolean }) {
  return (
    <div className={`flex rounded-lg p-0.5 ${isDark ? 'bg-gray-700' : 'bg-gray-100'}`}>
      {OPTIONS.map(o => (
        <button key={o.value} onClick={() => onChange(o.value)}
          className={`px-2 py-1 text-xs font-medium rounded-md transition-colors ${
            scale === o.value
              ? isDark ? 'bg-blue-600 text-white' : 'bg-white text-blue-600 shadow-sm'
              : isDark ? 'text-gray-400 hover:text-gray-200' : 'text-gray-600 hover:text-gray-900'
          }`}>{o.label}</button>
      ))}
    </div>
  );
}
